/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  "::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    backgroundColor: "#f5f5f5",
  },
  "::-webkit-scrollbar-thumb": {
    borderRadius: 8,
    backgroundColor: "#c1c1c1",
    minHeight: 24,
    border: "2px solid #f5f5f5",
  },
  "::-webkit-scrollbar-thumb:focus": {
    backgroundColor: "#a8a8a8",
  },
  "::-webkit-scrollbar-thumb:active": {
    backgroundColor: "#a8a8a8",
  },
  "::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#a8a8a8",
  },
  "::-webkit-scrollbar-corner": {
    backgroundColor: "#f5f5f5",
  },
};

export default globals;
